module.exports = __webpack_public_path__ + "img/tick_icon.be516a7b.svg";